<template>
  <div class="card">
      <div class="card-header bg-transparent text-left">
        <strong>Faturamento no(s) ultimo(s) {{periodText}}</strong>
      </div>

      <div class="card-body">
          <sales 
            :period="period"
            :period-type="periodType"
            :height="height"
          />
      </div>

      <div class="card-footer bg-transparent text-left" v-if="pShowPeriod" >
          <div class="row" >
              <div class="col-md-8 text-left" >
                <a href="#" class="btn btn-transparent btn-sm">Veja mais</a>  
              </div>
              <div class="col-md-4 text-right" >
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" v-bind:class="[active == 1 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 2, periodType = 'month', active = 1]" class="btn btn-sm">3 Meses</button>
                  <button type="button" v-bind:class="[active == 2 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 5, periodType = 'month', active = 2]"  class="btn btn-sm">6 Meses</button>
                  <button type="button" v-if="pShowPeriod" v-bind:class="[active == 3 ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 12, periodType = 'month', active = 3]"  class="btn btn-sm">12 Meses</button>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
    import sales from '@/components/graphs/sales.vue'
    export default {
        name: 'homeSales',
        props: [
          'height',
          'pShowPeriod'
        ],
        components:{
          sales
        },
        data(){
          return {
            active: 2,
            period: 5,
            periodType: 'month',
            periodText: '6 Meses'
          }
        },
        watch: {
          period: function(newVal, oldVal){
            if(newVal == 2){
              this.periodText = '3 Meses'
            }else if(newVal == 5){
              this.periodText = '6 Meses'
            }else{
              this.periodText = '12 Meses'
            }
          }
        }       
    }
</script>